"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SbHint = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactTether = _interopRequireDefault(require("react-tether"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _constants = require("./constants");

var _utils = require("./utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * @todo make onClose listener for external usage
 */
var SbHint = /*#__PURE__*/function (_Component) {
  _inherits(SbHint, _Component);

  var _super = _createSuper(SbHint);

  function SbHint(props) {
    var _this;

    _classCallCheck(this, SbHint);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "handleOnMouseEnter", function () {
      var _this$props = _this.props,
          disableMouse = _this$props.disableMouse,
          showDelay = _this$props.showDelay,
          onMouseEnter = _this$props.onMouseEnter;

      if (disableMouse) {
        return;
      }

      clearTimeout(_this.debounceHide);

      if (showDelay > 0) {
        _this.debounceShow = setTimeout(_this.openHint, showDelay);
      } else {
        _this.openHint();
      }

      onMouseEnter();
    });

    _defineProperty(_assertThisInitialized(_this), "handleOnMouseLeave", function () {
      var _this$props2 = _this.props,
          disableMouse = _this$props2.disableMouse,
          hideDelay = _this$props2.hideDelay,
          onMouseLeave = _this$props2.onMouseLeave;

      if (disableMouse) {
        return;
      }

      clearTimeout(_this.debounceShow);

      if (hideDelay > 0) {
        _this.debounceHide = setTimeout(_this.closeHint, hideDelay);
      } else {
        _this.closeHint();
      }

      onMouseLeave();
    });

    _defineProperty(_assertThisInitialized(_this), "openHint", function () {
      _this.setState({
        isOpen: true
      });
    });

    _defineProperty(_assertThisInitialized(_this), "closeHint", function () {
      _this.setState({
        isOpen: false
      });
    });

    var open = props.open;
    _this.state = {
      isOpen: typeof open === 'boolean' ? open : props.initialOpen
    };
    _this.debounceHide = null;
    _this.debounceShow = null;
    return _this;
  }

  _createClass(SbHint, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      clearTimeout(this.debounceHide);
      clearTimeout(this.debounceShow);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          className = _this$props3.className,
          children = _this$props3.children,
          hintData = _this$props3.hintData,
          hintClassName = _this$props3.hintClassName,
          hintStyle = _this$props3.hintStyle,
          id = _this$props3.id,
          position = _this$props3.position,
          style = _this$props3.style,
          wrapperClassName = _this$props3.wrapperClassName,
          wrapperStyle = _this$props3.wrapperStyle,
          hintOffset = _this$props3.hintOffset;
      var isOpen = this.state.isOpen; // Inverse the positions (because by default they are pivot points, and it is harder to understand how it works)

      var vertical = (0, _utils.getVerticalPosition)(position.vertical);
      var horizontal = (0, _utils.getHorizontalPosition)(position.horizontal);
      var wrapperClassNames = (0, _classnames.default)('sb-hint', wrapperClassName, className);
      var wrapperStyles = Object.assign({}, wrapperStyle, style);
      return /*#__PURE__*/_react.default.createElement("div", {
        className: wrapperClassNames,
        onMouseEnter: this.handleOnMouseEnter,
        onMouseLeave: this.handleOnMouseLeave,
        id: id,
        style: wrapperStyles,
        role: "tooltip"
      }, /*#__PURE__*/_react.default.createElement(_reactTether.default, {
        attachment: "".concat(vertical, " ").concat(horizontal),
        className: (0, _classnames.default)('hint-tether', hintClassName),
        constraints: [{
          to: 'scrollParent'
        }],
        style: hintStyle,
        targetAttachment: "auto auto",
        offset: hintOffset
      }, children, isOpen && /*#__PURE__*/_react.default.createElement("div", null, hintData)));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps) {
      var open = nextProps.open;

      if (typeof open === 'boolean') {
        return {
          isOpen: open
        };
      }

      return null;
    }
  }]);

  return SbHint;
}(_react.Component);

exports.SbHint = SbHint;

_defineProperty(SbHint, "propTypes", {
  className: _propTypes.default.string,
  disableMouse: _propTypes.default.bool,
  children: _propTypes.default.element.isRequired,
  hideDelay: _propTypes.default.number,
  hintData: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.element]).isRequired,
  hintClassName: _propTypes.default.string,
  hintStyle: _propTypes.default.object,
  // eslint-disable-line
  id: _propTypes.default.string,
  initialOpen: _propTypes.default.bool,
  open: _propTypes.default.bool,
  position: _propTypes.default.shape({
    horizontal: _propTypes.default.oneOf([_constants.horizontalPosition.LEFT, _constants.horizontalPosition.CENTER, _constants.horizontalPosition.RIGHT]),
    vertical: _propTypes.default.oneOf([_constants.verticalPosition.TOP, _constants.verticalPosition.MIDDLE, _constants.verticalPosition.BOTTOM])
  }),
  showDelay: _propTypes.default.number,
  style: _propTypes.default.object,
  // eslint-disable-line
  wrapperClassName: _propTypes.default.string,
  wrapperStyle: _propTypes.default.object,
  // eslint-disable-line
  hintOffset: _propTypes.default.string,
  onMouseLeave: _propTypes.default.func,
  onMouseEnter: _propTypes.default.func
});

_defineProperty(SbHint, "defaultProps", {
  className: null,
  disableMouse: false,
  hideDelay: 0,
  // hide time after mouse leave, in ms.
  hintClassName: '',
  hintStyle: {},
  id: null,
  initialOpen: false,
  open: null,
  // open is a boolean, but by default it is null since we don't want to use it.
  position: {
    horizontal: _constants.horizontalPosition.RIGHT,
    vertical: _constants.verticalPosition.MIDDLE
  },
  showDelay: 0,
  // show time on mouse enter, in ms.
  style: null,
  wrapperClassName: '',
  wrapperStyle: {},
  hintOffset: '0 0',
  onMouseLeave: function onMouseLeave() {},
  onMouseEnter: function onMouseEnter() {}
});
//# sourceMappingURL=sb-hint.js.map